import axios from 'Src/helpers/api/axiosInstance';
import { AppUser } from 'Src/views/App/App';

export interface TournamentEventParticipationSummaryItem {
  userId: string;
  eventId: string;
  isRelay: boolean;
  startTime: string;
  sportId: string;
  sportName: string;
  shortDescription: string;
}

export function getTournamentEventParticipationSummary(
  user: AppUser,
  tournamentId: string,
  userIds: string[]
): Promise<TournamentEventParticipationSummaryItem[]> {
  const { roleSessionKey: key, activeSchoolId } = user;
  return axios
    .post(
      `${window.apiBase}/i/schools/${activeSchoolId}/schools/tournaments/${tournamentId}/events/participation-summary`,
      { userIds },
      { headers: { usid: key } }
    )
    .then(response => response.data);
}

export function updateTournamentEventIndividualsForSchool(
  user: AppUser,
  eventId: string,
  participantSchoolId: string,
  data: { add?: any[]; remove?: string[]; update?: any[] },
  allowTournamentParticipationLimitOverride = false
) {
  const { roleSessionKey: key, activeSchoolId } = user;
  return axios
    .post(
      `${window.apiBase}/i/schools/${activeSchoolId}/events/${eventId}/participantSchools/${participantSchoolId}/individuals/batch`,
      data,
      {
        headers: { usid: key },
        params: { allowTournamentParticipationLimitOverride }
      }
    )
    .then(response => response.data);
}

export function updateTournamentEventTeamPlayersForSchool(
  user: AppUser,
  eventId: string,
  participantSchoolId: string,
  teamId: string,
  data: { add?: any[]; remove?: string[]; update?: any[] },
  allowTournamentParticipationLimitOverride = false
) {
  const { roleSessionKey: key, activeSchoolId } = user;
  return axios
    .post(
      `${window.apiBase}/i/schools/${activeSchoolId}/events/${eventId}/participantSchools/${participantSchoolId}/teams/${teamId}/players/batch`,
      data,
      {
        headers: { usid: key },
        params: { allowTournamentParticipationLimitOverride }
      }
    )
    .then(response => response.data);
}
